import setImagePreviewLoaded from '../actions/setImagePreviewLoaded';
import { mutator } from 'satcheljs';

mutator(setImagePreviewLoaded, actionMessage => {
    const { viewState } = actionMessage;
    viewState.imageLoaded = true;
    viewState.isImageLoading = false;
});
